<!-- Start::título -->
<div class="field mb-4">
  <span class="text-900 text-2xl block font-semibold mb-5"
    >Completa tus datos personales</span
  >
</div>
<!-- End::título -->

<!-- Start::descripción -->
<div
  class="p-4 mt-3 surface-100 flex align-items-center justify-content-between mb-2"
>
  <span class="mr-3 md:mr-5 text-sm">
    Ingresa tus datos para que podamos entregar tu compra de manera segura.
    Estos datos se utilizarán para el envío de notificaciones de la compra.
  </span>
  <i class="fa-sharp-duotone fa-solid fa-circle-info text-4xl"></i>
</div>
<!-- End::descripción -->

<!-- Start::informacion para facturar -->
<!-- <div
  class="p-4 mt-2 surface-100 flex align-items-center justify-content-between mb-4"
>
  <span class="mr-3 md:mr-5 text-sm">
    Para comprar con factura, crea una cuenta como empresa e ingresa a ella.
    Esto activará la opción de facturación al final del pago.
  </span>
  <i class="fa-sharp-duotone fa-solid fa-circle-info text-4xl"></i>
</div> -->
<!-- End::informacion para facturar -->

<!-- Start::formulario de contacto -->
<form
  #contactFormElement
  [formGroup]="contactForm"
  (ngSubmit)="nativeSubmit()"
>
  <!-- Start::input email -->
  <div class="field mb-4 flex flex-column">
    <label for="email" class="font-semibold text-900"
      >Correo electrónico</label
    >
    <app-email-input
      #emailInput
      formControlName="email"
      id="email"
      [useEmailExistsValidator]="true"
      (alreadyExistsError)="openLoginModal()"
    />
    <small id="email-help"> Ej: micorreo&#64;gmail.com </small>
  </div>
  <!-- End::input email -->

  <!-- Start::input nombre -->
  <div class="field mb-4 flex flex-column">
    <label for="name" class="font-semibold text-900">Nombres</label>
    <app-name-input id="firstName" formControlName="firstName" />
    <small id="firstName-help"> Ej: Nicolás </small>
  </div>
  <!-- End::input nombre -->

  <!-- Start::input apellido -->
  <div class="field mb-4 flex flex-column">
    <label for="lastName" class="font-semibold text-900">Apellidos</label>
    <app-name-input id="lastName" formControlName="lastName" />
    <small id="lastName-help"> Ej: Rojas </small>
  </div>
  <!-- End::input apellido -->

  <!-- Start::input documento -->
  <div class="field mb-4 flex flex-column">
    <label for="phone" class="font-semibold text-900">{{
      documentIdLabel
    }}</label>
    <app-document-id-input id="documentId" formControlName="documentId" />
    <small id="documentId-help"> Ej: {{ documentIdSample }} </small>
  </div>
  <!-- End::input documento -->

  <!-- Start::input teléfono -->
  <div class="field mb-4 flex flex-column">
    <label for="phone" class="font-semibold text-900">Teléfono</label>
    <app-phone-input id="phone" formControlName="phone" />
    <small id="phone-help"> Ej: 9 1234 9876 </small>
  </div>
  <!-- End::input teléfono -->
</form>
<!-- End::formulario de contacto -->
